import { render, staticRenderFns } from "./OrderAcceptModal.vue?vue&type=template&id=c932f1f8&scoped=true"
import script from "./OrderAcceptModal.vue?vue&type=script&lang=js"
export * from "./OrderAcceptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c932f1f8",
  null
  
)

export default component.exports